import React from 'react';
import { Link } from 'react-router-dom';

const propTypes = {};
const defaultProps = {};

const Strings = require('../../../../app/shared/Strings');
import CurrentYear from '../common/CurrentYear';

export default function SignedOutFooter(props) {
    return (
        <div className="signed-out-footer">
            <div>
                {Strings['en'].common.AUTHOR} © <CurrentYear /> {Strings['en'].common.MUZZY_LANE}
            </div>
            <div>
                <ul>
                    <li><Link to="/terms" target="_blank">{Strings['en'].signed_out.TERMS_OF_USE}</Link></li>
                    <li><Link to="/privacy" target="_blank">{Strings['en'].signed_out.PRIVACY_POLICY}</Link></li>
                    <li><a href="https://www.muzzylane.com/contact-us/" target="_blank">{Strings['en'].signed_out.CONTACT_US}</a></li>
                </ul>

            </div>
        </div>
    );
}

SignedOutFooter.propTypes = propTypes;
SignedOutFooter.defaultProps = defaultProps;